import { Injectable } from '@angular/core';

import { FinancialPaths } from '@gipi-paths/financial.paths';
import { GIPIBaseAbstractFilterModel } from '@gipi-shared/models/base-abstract-filter.model';
import { GIPIAbstractCrudService, GIPIBaseService } from '@gipisistemas/ng-core';
import { FinancialCardAdministrator } from '../models/card-administrador.model';

@Injectable({ providedIn: 'root' })
export class FinancialCardAdministratorService extends GIPIAbstractCrudService<FinancialCardAdministrator, GIPIBaseAbstractFilterModel> {

    constructor(protected baseService: GIPIBaseService,) {
        super(FinancialPaths.cardAdministrator, 'v1', baseService);
    }

}
